module.exports = __webpack_public_path__ + "img/vip_sign_3.8a6c18c8.png";